// dependencies.
import { get } from 'lodash'

// detect the base URL.
const apiNODE = get(process.env, 'API_NODE_URL')

/**
 * detect the api base URL
 */
export default apiNODE



// WEBPACK FOOTER //
// ./src/plugins/http/apiNODE.js